import { render, staticRenderFns } from "./r-task-action.vue?vue&type=template&id=62692226"
import script from "./r-task-action.vue?vue&type=script&lang=js"
export * from "./r-task-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62692226')) {
      api.createRecord('62692226', component.options)
    } else {
      api.reload('62692226', component.options)
    }
    module.hot.accept("./r-task-action.vue?vue&type=template&id=62692226", function () {
      api.rerender('62692226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-task-action.vue"
export default component.exports